import { QueryHookOptions } from '@apollo/client';
import gql from 'graphql-tag';
import { ContentActionGq } from '../../models/ContentActionGq';
import { useCustomQuery } from '../../../../logic/api/graphQL/useCustomQuery';

export function useGetContentActionsGq(
  command: CommandGq,
  options?: QueryHookOptions<DataGq, VariablesGq>
) {
  const query = useCustomQuery<DataGq, VariablesGq>(gqTag, {
    variables: { command },
    fetchPolicy: 'cache-and-network',
    ...options,
  });

  return {
    query,
    contentActions: (query?.data ?? query?.previousData)?.projects?.getContentActions
      ?.contentActions,
  };
}

const gqTag = gql`
  query GetContentActions($command: GetContentActionsCommand!) {
    projects {
      getContentActions(command: $command) {
        contentActions
      }
    }
  }
`;

interface DataGq {
  readonly projects: {
    readonly getContentActions: {
      readonly contentActions: ContentActionGq[];
    };
  };
}

export interface VariablesGq {
  command: CommandGq;
}

export interface CommandGq {
  projectId: number;
}
